export const PATERNITY_EXAM_CODES = ['PATMATER', 'PAT', 'PATDUO', 'PATRECONS']

/**
 * Verifica se uma amostra é de paternidade.
 * Suporta ambas as origens AOL (paternity_relationship) e LIS (exams[].code).
 * @param {Object} sample
 * @returns {boolean}
 */
export function isSamplePaternity(sample) {
  if (sample.paternity_relationship) return true
  return (
    sample.exams?.some(exam => PATERNITY_EXAM_CODES.includes(exam.code?.toUpperCase())) ??
    false
  )
}
